import { AuthService } from './../../../../../auth/services/auth/auth.service';
import { MUser } from '@argalis-apps/models';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DemandeEncadrementService } from '../../../../services/demande-encadrement/demande-encadrement.service';

@Component({
  selector: 'ags-info-session',
  templateUrl: './info-session.component.html',
  styleUrls: ['./info-session.component.scss']
})
export class InfoSessionComponent implements OnInit {
  private userConnected: MUser.CUser = null;
  public demandes: any;
  public isLoaded: boolean;
  public linkSession: string;
  @Output() public demandesOutput = new EventEmitter<any[]>();
  @Output() public goToDetailOutput = new EventEmitter<number>();
  @Input() detail;
  constructor(private demandeService: DemandeEncadrementService, private authService: AuthService) {
    this.userConnected = this.authService.userConnected;
  }

  ngOnInit() {
    const idIntervenant = this.userConnected.userInfo.id;
    // on rafraichit le nombre de notification sur la sidebar à l'affichage
    this.demandeService.getListById(idIntervenant).subscribe((res: any) => {
      if (res) {
        this.demandesOutput.emit(res);
      }
    });
    this.linkSession = `/account/sessions/ficheSession/${this.detail.id}`;
  }
}
